import { useMemo } from "react";

import { useModelCompareTranslation } from "constants/modelCompareData/translations/useModelCompareTranslation";
import * as S from "../../ProductList.styles";
import { groupProducts } from "./groupProducts";
import type { ProductGroupsProps } from "./ProductGroups.types";

export const ProductGroups = ({
  products,
  activeGroup,
  playAnimation,
  canPlayAniimation,
  showProductGroups,
}: ProductGroupsProps) => {
  const groupedGroups = useMemo(() => groupProducts(products), [products]);

  const { formatMessage } = useModelCompareTranslation();

  return (
    <S.ProductGroups $columns={products.length}>
      {groupedGroups.map(({ productListGroup, span }) => {
        const isActive =
          canPlayAniimation &&
          playAnimation &&
          activeGroup === productListGroup?.id;

        return productListGroup ? (
          <S.ProductGroupLabelContainer key={productListGroup.id} $span={span}>
            <S.ProductGroupLabel
              id={productListGroup.id}
              $isActive={isActive}
              $productGroupsSelectorExists={showProductGroups}
            >
              {formatMessage(productListGroup?.title)}{" "}
              {formatMessage("commons.productList.series")}
            </S.ProductGroupLabel>
            <S.ProductGroupLabelLineContainer>
              <S.ProductGroupLabelGrayLine>
                <S.ProductGroupLabelLine
                  $isActive={isActive}
                  $playAnimation={playAnimation}
                  $productGroupsSelectorExists={showProductGroups}
                />
              </S.ProductGroupLabelGrayLine>
            </S.ProductGroupLabelLineContainer>
          </S.ProductGroupLabelContainer>
        ) : null;
      })}
    </S.ProductGroups>
  );
};
